import { Component, Input, OnInit } from '@angular/core';
import { IComponentDef } from '../../../shared/interfaces';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[d-widget-form-item]',
  templateUrl: './d-widget-form-item.component.html',
  styles: []
})
export class DWidgetFormItemComponent {
  @Input() item: IComponentDef;

  constructor() {}

  getComponent(widget: string) {
    if (!widget) {
      return '';
    }

    if (widget.startsWith('d-')) {
      return widget;
    }

    return `d-${widget}`;
  }
}
